import {campaignsSellerService, placementSellerService} from 'services/seller';
import Vue from 'vue';
import {getIconConnectionById} from 'utils/seller/sellerConnectionData';
import {channelsService} from 'services';
import delay from 'utils/api/delay';

export const FETCH_CAMPAIGNS_CURRENT_USER = 'FETCH_CAMPAIGNS_CURRENT_USER';
export const FETCH_METRICS_FOR_CAMPAIGNS = 'FETCH_METRICS_FOR_CAMPAIGNS';
export const SET_CAMPAIGNS = 'SET_CAMPAIGNS';
export const SET_PLACEMENT_TYPES = 'SET_PLACEMENT_TYPES';
export const SET_CHANNELS = 'SET_CHANNELS';
export const SET_ITEMS_TOTAL = 'SET_ITEMS_TOTAL';
export const SET_METRICS_FOR_CAMPAIGNS = 'SET_METRICS_FOR_CAMPAIGNS';
export const FETCH_PLACEMENT_TYPES = 'FETCH_PLACEMENT_TYPES';
export const FETCH_CHANNELS_CURRENT_USER = 'FETCH_CHANNELS_CURRENT_USER';
export const CHANGE_CAMPAIGNS_STATUS = 'CHANGE_CAMPAIGNS_STATUS';
export const REPLACE_CAMPAIGN_ITEM = 'REPLACE_CAMPAIGN_ITEM';
export const REPLACE_KEY_VALUE_CAMPAIGN_ITEM = 'REPLACE_KEY_VALUE_CAMPAIGN_ITEM';
export const EDIT_SCHEDULE_PLACEMENT = 'EDIT_SCHEDULE_PLACEMENT';
export const SWITCH_STRATEGY_STATUS = 'SWITCH_STRATEGY_STATUS';
export const SET_STRATEGY_LOADING = 'SET_STRATEGY_LOADING';
export const SET_PLACEMENT_LIST_REFRESH_TIME = 'SET_PLACEMENT_LIST_REFRESH_TIME';
export const REFRESH_PLACEMENT_LIST = 'REFRESH_PLACEMENT_LIST';

const campaignsStore = {
  namespaced: true,
  state: {
    campaigns: [],
    metricsData: [],
    channels: [],
    itemsTotal: 0,
    placementTypes: [],
    loadingStatusByCampaignId: {},
    campaignsLastRefreshAt: null,
    isCampaignRefreshAllowed: true
  },
  getters: {
    campaignsList (state) {
      const getMetricStatByGroupId = (groupId) => state.metricsData.find(metric => metric.id === groupId) || {};

      return state.campaigns.map(campaign => ({
        ...campaign,
        progressMetricsStats: getMetricStatByGroupId(campaign.group_id),

        /*
         * todo: костыль, жду от бека фикс
         * можно удалять, когда в /api/seller/campaigns будет приходить progress_metrics
         */
        progress_metrics: {
          metrics: [
            'crr_fact',
            'orders_total'
          ]}
      }));
    },
    getCampaignById (state) {
      return findId => state.campaigns.find(campaign => campaign.id === findId);
    },
    itemsCampaignsTotal (state) {
      return state.itemsTotal;
    },
    placementTypesList (state) {
      return state.placementTypes;
    },
    channelListCurrentUser (state) {
      return state.channels.map(channel => ({
        ...channel,
        icon: getIconConnectionById(channel.id)
      }));
    },
    channelIcons: state => state.channels.reduce((acc, c) => {
      acc[c.id] = c.icon;
      return acc;
    }, {}),
    isStrategyDisabled (state) {
      return (id) =>
        Boolean(state.loadingStatusByCampaignId[id]);
    },
    campaignsLastRefreshAt (state) {
      return state.campaignsLastRefreshAt;
    }
  },
  mutations: {
    [SET_CAMPAIGNS] (state, campaigns) {
      state.campaigns = campaigns;
    },
    [SET_ITEMS_TOTAL] (state, itemsTotal) {
      state.itemsTotal = itemsTotal;
    },
    [SET_CHANNELS] (state, channels) {
      state.channels = channels.map(i => ({
        ...i,
        icon: channelsService.getIconByChannelName(i.name)
      }));
    },
    [SET_PLACEMENT_TYPES] (state, placementTypes) {
      state.placementTypes = placementTypes;
    },
    [SET_METRICS_FOR_CAMPAIGNS] (state, metricsData) {
      state.metricsData = metricsData;
    },
    [REPLACE_CAMPAIGN_ITEM] (state, updateCampaign) {
      for (const [index, campaign] of Object.entries(state.campaigns)) {
        if (campaign.id === updateCampaign.id) {
          Vue.set(state.campaigns, index, updateCampaign);
          break;
        }
      }
    },
    [SET_STRATEGY_LOADING] (state, {id, isLoading}) {
      Vue.set(state.loadingStatusByCampaignId, id, isLoading);
    },
    [SET_PLACEMENT_LIST_REFRESH_TIME] (state, time) {
      state.campaignsLastRefreshAt = time;
    }
  },
  actions: {
    [REPLACE_KEY_VALUE_CAMPAIGN_ITEM] (context, {campaignId, key, newValueKey}) {
      const newValueItem = context.getters.getCampaignById(campaignId);
      newValueItem[key] = newValueKey;

      context.commit(REPLACE_CAMPAIGN_ITEM, newValueItem);
    },
    async [FETCH_CAMPAIGNS_CURRENT_USER] (context, params) {
      const campaignsResponse = await campaignsSellerService.getCampaignsCurrentUser(params);

      const campaignsItems = campaignsResponse.items;
      const campaignsItemsTotal = campaignsResponse.items_total;

      context.commit(SET_CAMPAIGNS, campaignsItems);
      context.commit(SET_ITEMS_TOTAL, campaignsItemsTotal);
    },
    async [FETCH_METRICS_FOR_CAMPAIGNS] (context) {
      const metricsData = (await campaignsSellerService.getMetricsForCampaigns()).items;
      context.commit(SET_METRICS_FOR_CAMPAIGNS, metricsData);
    },
    async [FETCH_CHANNELS_CURRENT_USER] (context) {
      if (!context.getters.channelListCurrentUser?.length) {
        const channels = (await campaignsSellerService.getCurrentChannelsList()).items;
        context.commit(SET_CHANNELS, channels);
      }

      return context.getters.channelListCurrentUser;
    },
    async [FETCH_PLACEMENT_TYPES] (context) {
      const placementTypes = await campaignsSellerService.getPlacementTypesFromRepos();
      context.commit(SET_PLACEMENT_TYPES, placementTypes);
    },
    async [EDIT_SCHEDULE_PLACEMENT] (context, payload) {
      return await placementSellerService.editSchedulePlacements(payload);
    },
    async [CHANGE_CAMPAIGNS_STATUS] (context, payload) {
      await campaignsSellerService.changeCampaignStatus({
        id: payload.id,
        status: payload.status
      });
    },
    async [SWITCH_STRATEGY_STATUS] (context, payload) {
      if (context.getters.isStrategyDisabled(payload.id)) {
        return;
      }

      context.commit('SET_STRATEGY_LOADING', {id: payload.id, isLoading: true});

      try {
        if (payload.status) {
          await campaignsSellerService.enabledStrategy({strategy_id: payload.id});
        } else {
          await campaignsSellerService.disabledStrategy({strategy_id: payload.id});
        }
      } catch (e) {
        console.error(e.message);
      }

      context.commit('SET_STRATEGY_LOADING', {id: payload.id, isLoading: false});
      context.dispatch(REPLACE_KEY_VALUE_CAMPAIGN_ITEM, {
        campaignId: payload.campaignId,
        key: 'strategy_enabled',
        newValueKey: payload.status
      });
    },
    async [REFRESH_PLACEMENT_LIST] ({dispatch, commit}, payload = {}) {
      try {
        const {data} = await campaignsSellerService.refreshPlacementList();
        const {campaigns_last_refresh_at: time, new_campaigns_count: newCampaignsCount} = data;
        let itemsCount = 1;
        let attempts = 0;
        const MAX_ATTEMPTS = 10;
        const PENDING_DELAY_MS = 2000;

        if (newCampaignsCount > 0 && attempts < MAX_ATTEMPTS) {
          /* eslint-disable no-await-in-loop */
          while (itemsCount > 0) {
            const newCampaigns = await campaignsSellerService.pendingPlacementList();
            itemsCount = newCampaigns.items_total;

            if (itemsCount > 0) {
              attempts++;
              await delay(PENDING_DELAY_MS);
            }
          }

          await dispatch('FETCH_CAMPAIGNS_CURRENT_USER', payload);
          await dispatch('FETCH_CHANNELS_CURRENT_USER');
        }

        commit('SET_PLACEMENT_LIST_REFRESH_TIME', time);
        return newCampaignsCount;
      } catch (e) {
        console.error(e.message);
      }
    }
  }
};

export default campaignsStore;
